import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import closesquare from "../../assets/closesquare.svg";
import ButtonComponent from "../ButtonComponent/ButtonComponent";

function DialogComponent(props) {
    const { isOpen, maxWidth = "xs", isOuterClick, Title, onClose, children, IsLoading, onSave, SaveButtonName, ActionText, CancelButtonName } = props;
    const handleClose = () => {
        onClose(false)
    };

    // let lastWord = Title.substring(Title.lastIndexOf(" ") + 1);
    // 'xs'    | 'sm'    | 'md'    | 'lg'    | 'xl'
    // md = 900px lg = 1200px  xl = 1536px
    return (
        <Dialog
            open={isOpen}
            fullWidth={true}
            maxWidth={maxWidth}
            onClose={isOuterClick == undefined ? handleClose : isOuterClick}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '24px 24px 0' }}>
                    {/* <DialogTitle style={{ marginBottom: '0px' }} >
                    </DialogTitle> */}
                    <h2 className='dialog-heading'>{Title}</h2>

                    <img src={closesquare} className="dialog-close-icon" onClick={onClose} />
                </div>

                <DialogContent style={{ overflow: 'hidden', padding: '0 24px 24px' }}>
                    {children}
                </DialogContent>

                <DialogActions style={{ display: 'flex', justifyContent: 'center', padding: '0 24px 24px' }}>
                    <ButtonComponent size="half" color="primary" disabled={IsLoading ? true : false} onClick={onSave}>{SaveButtonName ? SaveButtonName : ActionText}</ButtonComponent>
                    {/* <ButtonComponent size="small" color="Typography" disabled={IsLoading ? true : false} onClick={handleClose}>{CancelButtonName ? CancelButtonName : "Cancel"}</ButtonComponent> */}
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default DialogComponent;
